"use client";

import { c as _c } from "react/compiler-runtime";
import { AccountLockup, AccountLockupAvatar, AccountLockupFragment, AccountLockupText } from "@opensea/app-kit";
import { readFragment, useClient } from "@opensea/graphql";
import { Avatar, Button, Item, ItemAvatar, ItemContent } from "@opensea/next-ui-kit";
import { AvatarBadge, classNames, FlexColumn, formatAddress, SkeletonBlock, TextBody, TextBodySkeleton, TextOverflowTooltip } from "@opensea/ui-kit";
import { AccountCircle, ExpandMore } from "@opensea/ui-kit/icons";
import { getChainArchFromAddress, useConnectors, useIsReady } from "@opensea/wallet";
import { prefetchProfileItemsPage } from "@/app/[locale]/[currency]/[persona]/(full-immersive)/profile/[heroHeaderView]/[identifier]/items/[userPreferences]/prefetch";
import { prefetchProfileTokensPage } from "@/app/[locale]/[currency]/[persona]/(full-immersive)/profile/[heroHeaderView]/[identifier]/tokens/[userPreferences]/prefetch";
import { getProfileUrlByIdentifier } from "@/components/profile/utils";
import { useBasicProfile } from "@/hooks/api/use-basic-profile";
import { useAddress } from "@/hooks/wallet";
import { useTopNavbarSkeletonClassNames } from "./hooks";
export function ProfileButton(t0) {
  const $ = _c(37);
  let dropdownOpen;
  let props;
  if ($[0] !== t0) {
    ({
      dropdownOpen,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = dropdownOpen;
    $[2] = props;
  } else {
    dropdownOpen = $[1];
    props = $[2];
  }
  const address = useAddress();
  const {
    activeConnector
  } = useConnectors();
  const ready = useIsReady();
  let t1;
  if ($[3] !== address) {
    t1 = getProfileUrlByIdentifier(address);
    $[3] = address;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const href = t1;
  const {
    profile,
    fetching
  } = useBasicProfile();
  const client = useClient();
  if (fetching) {
    let t2;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <ProfileButtonSkeleton />;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    return t2;
  }
  let t2;
  if ($[6] !== href || $[7] !== props) {
    t2 = <Button {...props} aria-label="Profile" className="px-4" href={href} icon={AccountCircle} variant="ghost" />;
    $[6] = href;
    $[7] = props;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const loggedOutProfile = t2;
  if (!address) {
    if (ready) {
      return loggedOutProfile;
    }
    let t3;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <ProfileButtonSkeleton />;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    return t3;
  }
  if (profile) {
    let t3;
    if ($[10] !== address || $[11] !== client) {
      t3 = () => {
        if (getChainArchFromAddress(address) === "SVM") {
          prefetchProfileTokensPage(address, client);
        } else {
          prefetchProfileItemsPage(address, client);
        }
      };
      $[10] = address;
      $[11] = client;
      $[12] = t3;
    } else {
      t3 = $[12];
    }
    const t4 = activeConnector?.name;
    const t5 = activeConnector?.icon;
    let t6;
    if ($[13] !== t4 || $[14] !== t5) {
      t6 = <AccountLockupAvatar badge={<AvatarBadge className="p-0" size="xs"><Avatar alt={t4} src={t5} /></AvatarBadge>} size={24} />;
      $[13] = t4;
      $[14] = t5;
      $[15] = t6;
    } else {
      t6 = $[15];
    }
    const t7 = address ?? null;
    let t8;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <TextOverflowTooltip className="max-w-[120px] leading-none" disabled={true}><TextBody className="leading-none" weight="semibold"><AccountLockupText /></TextBody></TextOverflowTooltip>;
      $[16] = t8;
    } else {
      t8 = $[16];
    }
    let t9;
    if ($[17] !== address || $[18] !== profile) {
      t9 = readFragment(AccountLockupFragment, profile).displayName && address ? <TextBody className="leading-none" color="text-secondary" size="xs" weight="regular">{formatAddress(address)}</TextBody> : null;
      $[17] = address;
      $[18] = profile;
      $[19] = t9;
    } else {
      t9 = $[19];
    }
    let t10;
    if ($[20] !== t9) {
      t10 = <FlexColumn className="min-w-0 gap-1">{t8}{t9}</FlexColumn>;
      $[20] = t9;
      $[21] = t10;
    } else {
      t10 = $[21];
    }
    let t11;
    if ($[22] !== profile || $[23] !== t10 || $[24] !== t6 || $[25] !== t7) {
      t11 = <AccountLockup account={profile} addressDisplay="compact" avatar={t6} className="shrink gap-3" connectedAddress={t7} displayYou={false} isLink={false}>{t10}</AccountLockup>;
      $[22] = profile;
      $[23] = t10;
      $[24] = t6;
      $[25] = t7;
      $[26] = t11;
    } else {
      t11 = $[26];
    }
    const t12 = dropdownOpen && "rotate-180";
    let t13;
    if ($[27] !== t12) {
      t13 = classNames("shrink-0 transition duration-150 ease-out-quint", t12);
      $[27] = t12;
      $[28] = t13;
    } else {
      t13 = $[28];
    }
    let t14;
    if ($[29] !== t13) {
      t14 = <ExpandMore className={t13} size={20} />;
      $[29] = t13;
      $[30] = t14;
    } else {
      t14 = $[30];
    }
    let t15;
    if ($[31] !== href || $[32] !== props || $[33] !== t11 || $[34] !== t14 || $[35] !== t3) {
      t15 = <Button {...props} aria-label="Profile" className="gap-1 px-4" href={href} onPointerOver={t3} variant="ghost">{t11}{t14}</Button>;
      $[31] = href;
      $[32] = props;
      $[33] = t11;
      $[34] = t14;
      $[35] = t3;
      $[36] = t15;
    } else {
      t15 = $[36];
    }
    return t15;
  }
  return loggedOutProfile;
}
function ProfileButtonSkeleton() {
  const $ = _c(9);
  const skeletonClassNames = useTopNavbarSkeletonClassNames();
  let t0;
  if ($[0] !== skeletonClassNames) {
    t0 = <ItemAvatar className="mr-1" rounded={true} size={28}><SkeletonBlock className={skeletonClassNames} /></ItemAvatar>;
    $[0] = skeletonClassNames;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== skeletonClassNames) {
    t1 = classNames("w-12", skeletonClassNames);
    $[2] = skeletonClassNames;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = <ItemContent><TextBodySkeleton className={t1} /></ItemContent>;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t0 || $[7] !== t2) {
    t3 = <Item className="w-auto px-4" variant="unstyled">{t0}{t2}</Item>;
    $[6] = t0;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}